module.exports = __webpack_public_path__ + "img/fear.29f48f30.jpg";